//import { inject } from "vue";
//全局参数文件
import config from "../../config/config";
// 公共处理函数
import zCommon from "./zCommon";
// 路由函数
import zRouter from "./zRouter";
// 全局方法
import zGlobal from "./zGlobal";
// 全局vuex
import zStore from "./zStore";

const $zeedoUtils = function () {
  let $zRouter = zRouter();
  let $zCommon = zCommon;
  let $zConfig = config;
  let $zGlobal = zGlobal;
  let $zStore = zStore;

  return {
    $zRouter,
    $zCommon,
    $zConfig,
    $zGlobal,
    $zStore,
  };
};
const uUtils = {
  install(Vue) {
    Vue.provide("$zeedoUtils", $zeedoUtils);
  },
  zeedoUtils: $zeedoUtils,
  $zGlobal: zGlobal,
  $zCommon: zCommon,
};
export default uUtils;
